module.exports = __webpack_public_path__ + "static/media/Discount.f25b0626.svg";